<template>
  <v-data-table :headers="headers" :items="filteredFacilitators" sort-by="position">
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo facilitador
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-if="facilitatorType === 'notes'"
                      outlined
                      dense
                      v-model="editedItem.text"
                      label="Texto"
                      rows="5"
                      :hide-details="!errors.editedItem"
                      :error-messages="errors.editedItem"
                    />

                    <v-text-field
                      v-else
                      outlined
                      dense
                      v-model="editedItem.text"
                      label="Texto"
                      :hide-details="!errors.editedItem"
                      :error-messages="errors.editedItem"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="chagePositionUp(item)">
          eva-arrow-down-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="chagePositionDown(item)">
          eva-arrow-up-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há facilitadores de Histórico da Moléstia Atual cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "ConfigHFList",
    props: {
      facilitators: Array,
      facilitatorType: String,
      refreshList: Function,
    },
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        headers: [
          { text: "Texto", value: "text" },
          { text: "Posição", value: "position" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
        filteredFacilitators: [],
      };
    },
    watch: {
      facilitators() {
        this.loadFacilitators();
      },
    },
    mounted() {
      this.loadFacilitators();
    },
    created() {
      this.loadFacilitators();
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Novo facilitador" : "Editar facilitador";
      },
    },
    methods: {
      loadFacilitators() {
        const facilitator = this.lodash.find(this.facilitators, {
          facilitatorType: this.facilitatorType,
        });

        if (facilitator) {
          this.filteredFacilitators = facilitator.values.map((e, index) => {
            return { text: e, position: index };
          });
        }
      },
      chagePositionDown(item) {
        this.repositionate(item, -1);
      },
      chagePositionUp(item) {
        this.repositionate(item, 1);
      },
      repositionate(item, positionChanger) {
        item.position += positionChanger;
        if (item.position < 0) {
          item.position = 0;
        }

        let facilitators = this.lodash.filter(this.filteredFacilitators, {
          position: item.position,
        });

        facilitators.forEach((e) => {
          if (e !== item) {
            e.position = e.position - positionChanger;
          }
        });

        facilitators = this.lodash.sortBy(this.filteredFacilitators, ["position"], ["asc"]);

        this.filteredFacilitators = facilitators;

        this.saveFacilitators({ message: "Posição alterada com sucesso." });
      },
      editItem(item) {
        this.editedIndex = this.filteredFacilitators.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          let deleteIndex = this.filteredFacilitators.indexOf(item);
          this.filteredFacilitators.splice(deleteIndex, 1);

          this.filteredFacilitators = this.filteredFacilitators.map((e, index) => {
            e.position = index;
            return e;
          });

          this.filteredFacilitators = this.lodash.sortBy(
            this.filteredFacilitators,
            ["position"],
            ["asc"]
          );

          this.saveFacilitators({ message: "Cadastro deletado com sucesso." });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        if (this.editedIndex > -1) {
          Object.assign(this.filteredFacilitators[this.editedIndex], this.editedItem);
        } else {
          this.editedItem.position = this.filteredFacilitators.length;
          this.filteredFacilitators.push(this.editedItem);
        }

        this.close();

        this.saveFacilitators({ message: "Cadastro salvo com sucesso." });
      },
      saveFacilitators({ message }) {
        this.apolloMutate({
          mutation: require("@/graphql/glasses_prescription/save_glasses_prescription_facilitator.gql"),
          variables: {
            values: this.filteredFacilitators.map((e) => e.text),
            facilitatorType: this.facilitatorType,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: message,
            type: "success",
          });
        });
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let text = this.editedItem.text;
        if (this.lodash.isEmpty(text?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
